// Datos ficticios de ejemplo — plantilla "Fiesta de Colores" (cumpleaños infantil).
// Contrato neutral: protagonista con nombre y edad; el resto de campos son comunes.

export const datosEjemplo = {
  tipoEvento: "infantil",
  plantillaId: "infantil-fiesta",

  secciones: [
    { id: "portada", visible: true, orden: 0 },
    { id: "cuentaRegresiva", visible: true, orden: 1, etiqueta: "¡Falta poquito!", titulo: "Contando los días", textoFinalizado: "¡Hoy es la fiesta!" },
    { id: "eventos", visible: true, orden: 2, etiqueta: "Dónde y cuándo", titulo: "La fiesta es aquí" },
    { id: "calendario", visible: true, orden: 3, etiqueta: "Agendalo", titulo: "Guardá la fecha" },
    { id: "galeria", visible: true, orden: 4, etiqueta: "Fotos", titulo: "Momentos felices" },
    { id: "itinerario", visible: true, orden: 5, etiqueta: "El plan", titulo: "Qué vamos a hacer" },
    { id: "menciones", visible: false, orden: 6, etiqueta: "Familia", titulo: "Quienes lo miman" },
    { id: "video", visible: false, orden: 7, etiqueta: "Video", titulo: "Mirá nuestro video" },
    { id: "musica", visible: true, orden: 8, etiqueta: "A cantar", titulo: "La música de la fiesta" },
    { id: "rsvp", visible: true, orden: 9, etiqueta: "Confirmación", titulo: "¿Venís a jugar?" },
    { id: "enlaces", visible: true, orden: 10, etiqueta: "Datos útiles", titulo: "Para los papás" },
    { id: "accesos", visible: true, orden: 11, etiqueta: "Participá", titulo: "Dejale tu huella" },
    { id: "cierre", visible: true, orden: 12 },
  ],

  protagonista: {
    nombre: "Benjamín",
    edad: 7,
    textoEdad: "años",
    fraseIntroductoria: "¡Cumplo años!",
    mensajePortada:
      "Vení a festejar conmigo una tarde llena de juegos, sorpresas y mucha torta.",
    mensajeCierre:
      "¡Gracias por venir a mi fiesta! La voy a pasar increíble con vos.",
    textoBotonEntrada: "¡Quiero ver todo!",
  },

  evento: {
    fechaISO: "2026-12-06T16:00:00-03:00",
    fechaLegible: "Sábado 6 de diciembre de 2026",
    fechaCorta: "06 · 12 · 2026",
    ciudad: "Fernando de la Mora, Paraguay",
  },

  fotos: {
    portada:
      "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&auto=format&fit=crop",
    galeria: [
      {
        src: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Torta de cumpleaños con velitas",
      },
      {
        src: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Globos de colores en la fiesta",
      },
      {
        src: "https://images.unsplash.com/photo-1513151233558-d860c5398176?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Confeti de colores en el aire",
      },
      {
        src: "https://images.unsplash.com/photo-1464349153735-7db50ed83c84?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Mesa dulce de cumpleaños",
      },
    ],
  },

  eventos: [
    {
      id: "fiesta",
      etiqueta: "La fiesta",
      lugar: "Salón Pequeño Mundo",
      direccion: "Av. Mariscal López esq. Curupayty, Fernando de la Mora",
      horario: "16:00 a 19:30 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Fernando+de+la+Mora+Paraguay",
      textoBoton: "Cómo llegar",
    },
  ],

  calendario: {
    titulo: "Cumpleaños de Benjamín (7 años)",
    descripcion: "Fiesta de 16:00 a 19:30 h en Salón Pequeño Mundo, Fernando de la Mora.",
    texto: "Sábado 6 de diciembre de 2026 · Fernando de la Mora. ¡Que no se te pase!",
    textoBotonGoogle: "Google Calendar",
    textoBotonIcs: "Descargar evento (.ics)",
    inicioISO: "2026-12-06T16:00:00-03:00",
    finISO: "2026-12-06T19:30:00-03:00",
    ubicacion: "Salón Pequeño Mundo, Fernando de la Mora, Paraguay",
  },

  itinerario: [
    { hora: "16:00", titulo: "¡Llegada!", descripcion: "Recibimos a todos con sorpresas.", icono: "fiesta" },
    { hora: "16:30", titulo: "Juegos y animación", descripcion: "Animadores, pelotero y concursos.", icono: "brillo" },
    { hora: "17:30", titulo: "Merienda", descripcion: "Pizzetas, jugos y cosas ricas.", icono: "cena" },
    { hora: "18:15", titulo: "Piñata", descripcion: "El momento más esperado.", icono: "copas" },
    { hora: "18:45", titulo: "La torta", descripcion: "Cantamos el feliz cumpleaños.", icono: "corazon" },
    { hora: "19:30", titulo: "Despedida", descripcion: "Bolsita de sorpresas para todos.", icono: "musica" },
  ],

  video: {
    urlYoutube: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
  },

  musica: {
    tipo: "spotify",
    url: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    nota: "Dale play para escuchar la música de la fiesta. Nunca arranca sola.",
  },

  rsvp: {
    mensaje:
      "Avisanos si venís así te guardamos tu lugar (y tu porción de torta).",
    textoBoton: "Confirmar asistencia",
    fechaLimite: "Por favor confirmá antes del 25 de noviembre de 2026",
  },

  enlaces: [
    { texto: "Sugerencias de regalos", url: "https://www.pinterest.com" },
    { texto: "Mapa de la zona", url: "https://www.google.com/maps/search/?api=1&query=Fernando+de+la+Mora+Paraguay" },
  ],

  accesos: {
    libroFirmas: {
      titulo: "Libro de firmas",
      texto: "Dejale un mensaje para cuando sea grande.",
    },
    album: {
      titulo: "Álbum colaborativo",
      texto: "Subí las fotos que saques en la fiesta.",
    },
  },

  legal: {
    urlPrivacidad: "https://pro360.com.py/privacidad",
    urlCondiciones: "https://pro360.com.py/condiciones",
    textoPrivacidad: "Privacidad",
    textoCondiciones: "Condiciones",
    marca: "Hecho con amor · Pro360 Invitaciones Digitales Plus",
  },
};
